


























































































































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {ChatStatus, ChatTemplate, ChatWorkflow} from '@/entities/chat'
import {getCompany} from '@/api/company'
import moment from 'moment'
import VueSlideUpDown from 'vue-slide-up-down'
import fname from '@/utils/string'
import {Action, Getter, namespace} from 'vuex-class'
import {CompanyAttributes} from '@/entities'
import {IBillingStarterPlanVisibility} from "@/utils/plan"
import {isVisibleOnPlan} from "@/utils/plan"

@Component<ChatMenu>({
    components: {VueSlideUpDown}
})
export default class ChatMenu extends Vue {
    @Prop(Object) public customData
    @Prop(Object) public templates!: { [templateId: number]: ChatTemplate }
    @Prop(Object) public workflows!: { [workflowId: number]: ChatWorkflow }
    @Prop(Object) public chatStatus!: ChatStatus
    @Prop(Function) public onSelectWorkflow // callback when select template
    @Prop(Function) public onSelectTemplate // callback when select template
    @Prop(Boolean) public canReply !: boolean
    @Prop(Boolean) public showWorkflow !: boolean

    @Action public setChatStatus

    public customFields?: object = []
    @Getter public visibleOnPlan !: IBillingStarterPlanVisibility

    public leaderboardConfiguration?: object = undefined
    public active = ''
    public activeTemplateId = ''
    public friendlyName = (name) => {
        const label = this.customData.custom_field_labels[name] ? this.customData.custom_field_labels[name] : name
        return fname(label)
    }
    // fields with _c
    public getCustomFields() {
        const labels = this.customData
        this.customFields = Object.keys(labels)
            .filter((a) => /_c$/.test(a) || a === 'theme' || a === 'segment')
            .filter((field) => this.customData.custom_field_visibility && this.customData.custom_field_visibility[field])
            .sort()
            .map((a) => ({
                k: a,
                v: Array.isArray(labels[a]) ? labels[a].join(', ') : labels[a]
            }))
            .filter((a) => a.v !== null)
    }

    public onClickMenu(item) {
        if (item === this.active) {
            this.active = ''
        } else {
            this.active = item
        }
    }

    public onClickTemplate(template: ChatTemplate) {
        if (!this.isTemplateClickable(template)) {
            return
        }

        this.activeTemplateId = String(template.id)

        this.onSelectTemplate(template)
    }

    public onNewTemplate() {
        const templateId = 0
        this.setChatStatus({...this.chatStatus, editing_template: templateId})
    }

    public onEditTemplate(id) {
        this.setChatStatus({...this.chatStatus, editing_template: id})
    }

    public getTemplateClass(template: ChatTemplate) {
        return {
            muted: this.isTemplateMuted(template),
            active: this.isTemplateActive(template),
            cursor: this.isTemplateClickable(template)
        }
    }

    public isVisibleOnPlan(key: string): boolean {
        return isVisibleOnPlan(this, key)
    }

    public isTemplateMuted(template: ChatTemplate) {
        return template.sent === '1' || !this.isTemplateClickable(template) // any chat already sent, mute it
    }

    public isTemplateActive(template: ChatTemplate) {
        return this.activeTemplateId === String(template.id)
    }

    public isTemplateClickable(template: ChatTemplate) {
        return !(template.permanent === '1' && this.customData.publishapproved !== null)
    }

    public get publishTitleTooltip() {
        switch (this.customData.publishapproved) {
            case '1':
                return {
                    title: 'Published',
                    tooltip: 'This comment has been published as a Testimonial.'
                }
            case '3':
                return {
                    title: 'Reviewed',
                    tooltip: 'This response has been published as AskNicely Review.'
                }
            case '2':
                return {
                    title: 'Hidden',
                    tooltip: 'Currently not showing in Testimonials.'
                }
            case '0':
                return {
                    title: 'Rejected',
                    tooltip: 'The customer declined to have their comment published.'
                }
            case '-1':
                return {
                    title: 'Waiting',
                    tooltip: 'We have already sent a publish request to this customer.'
                }
            default:
                return {
                    title: 'Publish',
                    tooltip: 'Request to publish this comment as a Testimonoal.'
                }
        }
    }

    public async getLeaderboardConfiguration() {
        const { data } = await getCompany([CompanyAttributes.leaderboard_configuration])
        if (data && data.hasOwnProperty('leaderboard_configuration')) {
            this.leaderboardConfiguration = await JSON.parse(data.leaderboard_configuration)
        }
    }

    public getCustomDataType(field) {
        return this.leaderboardConfiguration !== undefined
            && this.leaderboardConfiguration[field] !== undefined
            && this.leaderboardConfiguration[field].type !== undefined
            ? this.leaderboardConfiguration[field].type : undefined
    }

    public formatTimestamp(timestamp, format) {
        return moment.unix(timestamp).format(format)
    }

    public async mounted() {
        await this.getLeaderboardConfiguration()
        this.getCustomFields()
    }
}
